import type { MessageKey } from '../../i18n';

// ═══════════════════════════════════════════════════════════════════
// WEEKDAY AND MONTH NAMES, AS CATALOG KEYS (#310a).
//
// The league screens spell these out by hand rather than asking `Intl` —
// they pick a specific shape («søndag 3. mai 2026», «Man», «jan») that the
// standard formats do not produce, and the layouts are built around the
// width of those exact strings. The migration moves the WORDS into the
// catalog and leaves the shapes alone, so the rendered Norwegian is
// unchanged.
//
// These are DISPLAY names. `docs/architecture/DOMAIN_RULES.md` §4 still
// governs anything stored or compared — nothing here may become a key, and
// nothing here is ever parsed back.
// ═══════════════════════════════════════════════════════════════════

/** Indexed by `Date.getDay()` — 0 is Sunday. */
export const WEEKDAY_LONG_KEYS: MessageKey[] = [
  'seriespill.date.weekdayLong0',
  'seriespill.date.weekdayLong1',
  'seriespill.date.weekdayLong2',
  'seriespill.date.weekdayLong3',
  'seriespill.date.weekdayLong4',
  'seriespill.date.weekdayLong5',
  'seriespill.date.weekdayLong6',
];

/** Indexed by `Date.getDay()` — 0 is Sunday. */
export const WEEKDAY_SHORT_KEYS: MessageKey[] = [
  'seriespill.date.weekdayShort0',
  'seriespill.date.weekdayShort1',
  'seriespill.date.weekdayShort2',
  'seriespill.date.weekdayShort3',
  'seriespill.date.weekdayShort4',
  'seriespill.date.weekdayShort5',
  'seriespill.date.weekdayShort6',
];

/** Indexed by month number − 1 — 0 is January. */
export const MONTH_SHORT_KEYS: MessageKey[] = [
  'seriespill.date.monthShort0',
  'seriespill.date.monthShort1',
  'seriespill.date.monthShort2',
  'seriespill.date.monthShort3',
  'seriespill.date.monthShort4',
  'seriespill.date.monthShort5',
  'seriespill.date.monthShort6',
  'seriespill.date.monthShort7',
  'seriespill.date.monthShort8',
  'seriespill.date.monthShort9',
  'seriespill.date.monthShort10',
  'seriespill.date.monthShort11',
];

/** Indexed by month number − 1 — 0 is January. Spelled out in full. */
export const MONTH_LONG_KEYS: MessageKey[] = [
  'seriespill.date.monthLong0',
  'seriespill.date.monthLong1',
  'seriespill.date.monthLong2',
  'seriespill.date.monthLong3',
  'seriespill.date.monthLong4',
  'seriespill.date.monthLong5',
  'seriespill.date.monthLong6',
  'seriespill.date.monthLong7',
  'seriespill.date.monthLong8',
  'seriespill.date.monthLong9',
  'seriespill.date.monthLong10',
  'seriespill.date.monthLong11',
];
